import ScrollPage, { SectionItem } from "../../../Components/ScrollPage/ScrollPage";
import Section from "../../../Components/Section/Section";
import DroneEngine from "../../../Content/EngineExamples/DroneEngine";


interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Diesel Generator Engines",        id: "dieselGenoratorEngines" }
];


const DroneEnginePage: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <DroneEngine />
    </Section>
  </ScrollPage>
);

export default DroneEnginePage;